export default __webpack_public_path__ + "static/media/T564_CoC.134b8e57.pdf";